const ADD_SUPPLIER = "ADD_SUPPLIER";
const UPDATE_SUPPLIER = "ADD_SUPPLIER";
const DELETE_SUPPLIER = "DELETE_SUPPLIER";
const SUPPLIERS = "SUPPLIERS";
const SUPPLIERS_SEARCH = "SUPPLIERS_SEARCH";
const ADD_SUPPLIER_ERROR = "ADD_SUPPLIER_ERROR";
const SUPPLIER_DETAILS = "SUPPLIER_DETAILS";

export {
  ADD_SUPPLIER,
  UPDATE_SUPPLIER,
  DELETE_SUPPLIER,
  SUPPLIERS,
  SUPPLIERS_SEARCH,
  ADD_SUPPLIER_ERROR,
  SUPPLIER_DETAILS,
};
